type MaintenanceConfig = {
  apiKey: string;
  url: string;
  launchDarklyClientKey: string;
};

export const getConfigurationByEnv = (baseUrl?: string) => {
  let configs: MaintenanceConfig;

  const defaultConfig: MaintenanceConfig = {
    apiKey: '',
    launchDarklyClientKey: '',
    url: 'https://qa.vwmaintenancefeatureapp.svc.vwusa.io',
  };

  if (baseUrl) {
    configs = {
      ...defaultConfig,
      url: baseUrl,
    };
  } else {
    configs = {
      ...defaultConfig,
    };
  }

  return configs;
};